<template>
  <div class="z-main dark-color">
    <header class="z-header d-space-row" style="border-bottom:1px solid #515151;background: #fff;">
      <div>
        <router-link to="/my">
          <img class="hearIcon" src="../../assets/sysbars/left.png">
        </router-link>
      </div>
      <div class="dark-color">团队</div>
      <div></div>
    </header>
    <div class="dis-60"></div>
    <div style="box-sizing: border-box;padding: 10px;background: #515151;">
      <span>我的上级&nbsp;</span>
      <span>账户：{{team.parent.name}}</span>
      <span>{{team.parent.nickname}}</span>
    </div>
    <div class="my-up d-space-row">
      <div class="t-common pad-all d-space-column">
        <span>我的直推</span>
        <span class="t-bottom">{{team.straight}}</span>
      </div>
      <div class="t-common pad-all d-space-column">
        <span>团队总人数</span>
        <span class="t-bottom">{{team.total}}</span>
      </div>
      <div class="t-common pad-all d-space-column">
        <span>{{team.today}}</span>
        <span class="t-bottom">今日新增</span>
      </div>
      <div class="t-common pad-all d-space-column">
        <span>{{team.next_total}}</span>
        <span class="t-bottom">直属会员下级</span>
      </div>

    </div>
    <div class="layui-fluid" style="margin-top: 20px;">
      <div class="layui-card">
        <div class="layui-card-body" style="box-sizing: border-box;padding: 0 20px;">
          <input type="text" id="key" class="layui-input s-input" placeholder="请输入关键字查找" />
          <ul id="ztree" class="ztree"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    data() {
      return {
        team: {
          straight: 0, //直推人数
          total: 0, // 团队总人数
          today: 0, // 今日新增
          next_total: 0, // 直属会员下级
          parent: {
            nickname: "", //上级昵称
            name: "" // 上级代号
          }
        }
      }
    },
    computed: {

    },
    created() {
      this.getTeam()

      this.getTree()

    },
    mounted() {

    },
    methods: {
      getTeam() {
        this.get('api/users/myteam.html', {}).then((res) => {
          if (res.code == 0) {
            this.team = res.data
          }
        })
      },
      getTree() {
        $(document).ready(function() {
          /*配置*/
          var setting = {
            view: {
              nameIsHTML: true,
            },
            edit: {
              enable: false
            },
            data: {
              key: {
                name: 'item',
                icon: 'ticon'
              },
              simpleData: {
                enable: true,
                idKey: "id",
                pIdKey: "pid",
                nameKey: "item"
              },
              showTitle: false
            }
          };
          $.get(URL + 'user/user/team', {
            token: TOKEN
          }, function(rs) {
            $.fn.zTree.init($("#ztree"), setting, rs.data);
            //初始化模糊搜索方法
            fuzzySearch('ztree', '#key', null, true);
          })
        })
      }
    }
  }
</script>

<style>
  .s-input {
    border: 1px solid #ddd;
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
  }

  .my-up {
    box-sizing: border-box;
    padding: 10px;
    flex-wrap: wrap;
    /* background: #F8F8F8; */
  }

  .t-common {
    width: 50%;
    /* margin-top: 20px; */
    background: #F8F8F8;
  }

  .t-common:nth-child(1) {
    border-right: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
  }

  .t-common:nth-child(2) {
    border-bottom: 1px solid #f1f1f1;
  }

  .t-common:nth-child(3) {
    border-right: 1px solid #f1f1f1;
  }

  .t-bottom {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my/team.vue